import React from 'react';
import Box from '@mui/material/Box';
import logoSmall from '../assets/logos/logo-small.svg';

export interface OnboardingBrandHeaderProps {
  /**
   * The mark to show. Defaults to the small fox logo. Pages MAY pass a
   * different icon (e.g. the profile mark on ProfileSetupStep) — the point of
   * this component is a fixed SIZE and POSITION, not a single shared image, so
   * the content column below always starts at the same Y even when the icon
   * itself differs between steps.
   */
  src?: string;
  alt?: string;
}

/**
 * Consistent brand mark at the top of every onboarding / auth-flow page (#383).
 *
 * The auth surface used to split into "hero" screens (big fox/city
 * illustration on /login, /register, /welcome) and "bare" utility screens (no
 * brand at all on forgot/reset/2FA), so crossing between them read like
 * switching apps and the content jumped vertically. This pins every page's mark
 * to the SAME 72 px size and fixed spacing so the content column below starts
 * at the same Y everywhere — while still allowing a page-specific icon.
 */
const OnboardingBrandHeader: React.FC<OnboardingBrandHeaderProps> = ({
  src = logoSmall,
  alt = '',
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      pt: '48px',
      pb: '24px',
    }}
  >
    <Box component="img" src={src} alt={alt} sx={{ height: 72, width: 'auto', display: 'block' }} />
  </Box>
);

export default OnboardingBrandHeader;
